import React, { useEffect, useState } from "react";
import "../Home/Home.css"
import { ClearLocalStorage } from "../../Utils/Utils";
import MainLayout from "../MainLayout/MainLayout";
import { getHomePageContent } from "../../services/api/outer";

const NotFound = () => {
    const [homePageData, setHomePageData] = useState(null);
    const [loading, setLoading] = useState(true);
    useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [homePageDataResponse] =
                    await Promise.all([
                        getHomePageContent(),
                    ]);
                setHomePageData(homePageDataResponse);
                setLoading(false);
            } catch (error) {
                //console.error("Error fetching data", error);
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        ClearLocalStorage();
    }, []);

    if (
        loading ||
        homePageData === null
    ) {
        return <></>;
    }

    return (
        <div>
            <MainLayout homePageData={homePageData}>
                <div className="not-found-section">
                    <h1 className="error">404</h1>
                    <div className="page-heading">Ooops!!! The page you are looking for is not found</div>
                    <a className="back-home" href="/">Back to home</a>
                </div>
            </MainLayout>
        </div>
    );
}

export default NotFound
